import { FieldConfig } from '@components/UI-Components/ProductCard'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { filter, includes } from 'lodash'
import { useMemo } from 'react'

export const useFilterFieldsByChannel = (fields, clientType): FieldConfig[] => {
  return useMemo(() => {
    return filter(fields, option => {
      return (
        !option?.allowedForChannels?.length ||
        includes(
          option.allowedForChannels,
          VIPClientType[clientType] ? VIPChannel.Retail : VIPChannel.Wholesale
        )
      )
    })
  }, [fields, clientType])
}

export default useFilterFieldsByChannel
